import { create } from "zustand";

export const useAuthStore = create((set) => ({
  AccessToken: "",
  ExpiresIn: "",
  IdToken: "",
  RefreshToken: "",
  TokenType: "",
  setAuth: (auth: any) =>
    set({
      AccessToken: auth.AccessToken,
      ExpiresIn: auth.ExpiresIn,
      IdToken: auth.IdToken,
      RefreshToken: auth.RefreshToken,
      TokenType: auth.TokenType,
    }),
  isShowLogoutModal: false,
  setIsShowLogoutModal: (isShowLogoutModal: boolean) =>
    set({ isShowLogoutModal: isShowLogoutModal }),
}));
